angular.module('impactx.rfx').controller('RFQCEditCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'TranslationService',
    'BackService',
    '$config',
    '$mdDialog',
    'ConfirmationService',
    'ToolbarService',
    '$redirect',
    'RedirectAndSaveService',
    'WarningService',
    RFQCEditCtrl
]);

function RFQCEditCtrl($scope, dataGen, $routeParams, ToastService, TranslationService, BackService, $config, $mdDialog,
                      ConfirmationService, ToolbarService, $redirect, RedirectAndSaveService, WarningService) {
    var ctrl = this;

    ctrl.getAssignedContracts = function () {
        return $scope.data.headerData.contractRelation ? $scope.data.headerData.contractRelation.relation.assigned : undefined;
    };

    ctrl.getUseContracts = function () {
        return $scope.data.headerData.contractRelation != null && $scope.data.headerData.contractRelation != undefined;
    };

    ctrl.getAssignedLots = function () {
        return $scope.data.headerData.lotRelation ? $scope.data.headerData.lotRelation.relation.assigned : undefined;
    };

    ctrl.getUseLots = function () {
        return $scope.data.headerData.lotRelation != null && $scope.data.headerData.lotRelation != undefined;
    };

    ctrl.getAssignedTenders = function () {
        return $scope.data.headerData.tenderRelation ? $scope.data.headerData.tenderRelation.relation.assigned : undefined;
    };

    ctrl.getUseTenders = function () {
        return $scope.data.headerData.tenderRelation != null && $scope.data.headerData.tenderRelation != undefined;
    };

    $scope.supplierInputDataArray = [{field: "rfqcId", value: $routeParams.id}, {
        field: "assignedContracts",
        valueFunction: ctrl.getAssignedContracts
    },
        {field: "useContractsAssigned", valueFunction: ctrl.getUseContracts},
        {field: "assignedLots", valueFunction: ctrl.getAssignedLots},
        {field: "useLotsAssigned", valueFunction: ctrl.getUseLots},
        {field: "assignedTenders", valueFunction: ctrl.getAssignedTenders},
        {field: "useTendersAssigned", valueFunction: ctrl.getUseTenders}];
    $scope.scrollList = [];
    $scope.attachmentErrorList = [];
    $scope.supplierErrorList = [];
    $scope.smartFormErrorList = [];
    $scope.headerErrorList = [];
    $scope.errorList = [];
    $scope.errorListForSave = [];
    $scope.supplierIndex = [];
    $scope.availableBuyerSft = [];
    $scope.availableSupplierSft = [];
    $scope.supplierCascadeEmpty = false;
    $scope.noSmartForm = false;

    dataGen.getData($scope, {
        id: $routeParams.id,
        copy: !!$routeParams.copy
    }, "/rfx/view").then(function () {
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.save = TranslationService.get('save');
        $scope.trns.delete = TranslationService.get('delete');
        $scope.trns.abort = TranslationService.get('abort');
        $scope.trns.errorMin = TranslationService.get('error_min');
        $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
        $scope.scrollList.push({
            id: 'header', label: $scope.data.headerData.header, form: $scope.headerForm,
            additionalErrors: $scope.headerErrorList
        });
        $scope.scrollList.push({id: 'pictures', label: $scope.trns.pictures, form: $scope.picturesForm});
        if ($scope.data.headerData.contractRelation) {
            $scope.scrollList.push({
                id: 'contracts',
                label: $scope.data.headerData.contractRelation.label,
                form: $scope.contractsForm
            });
        }
        if ($scope.data.headerData.lotRelation) {
            $scope.scrollList.push({
                id: 'lots',
                label: $scope.data.headerData.lotRelation.label,
                form: $scope.lotsForm
            });
        }
        $scope.scrollList.push({
            id: 'terms',
            label: $scope.data.conditionsAndAttachmentsData.header,
            form: $scope.termsForm
        });
        $scope.scrollList.push({
            id: 'termsAttachments',
            label: $scope.trns.termsAttachments,
            form: $scope.termsAttachmentsForm
        });
        $scope.scrollList.push({
            id: 'attachments', label: $scope.trns.attachments, form: $scope.attachmentsForm,
            additionalErrors: $scope.attachmentErrorList
        });
        $scope.scrollList.push({
            id: 'supplier', label: $scope.data.supplierAndCommunicationData.supplierHeader, form: $scope.supplierForm,
            additionalErrors: $scope.supplierErrorList
        });
        $scope.scrollList.push({
            id: 'communication',
            label: $scope.data.supplierAndCommunicationData.communicationHeader,
            form: $scope.communicationForm
        });
        $scope.scrollList.push({
            id: 'smartform', label: $scope.data.positionAndSmartFormData.smartFormHeader, form: $scope.smartformForm,
            additionalErrors: $scope.smartFormErrorList
        });
        $scope.scrollList.push({
            id: 'position',
            label: $scope.data.positionAndSmartFormData.positionHeader,
            form: $scope.positionForm
        });
        $scope.scrollList.push({id: 'deadlines', label: $scope.data.deadlinesData.header, form: $scope.deadlinesForm});
        $scope.scrollList.push({id: 'decision', label: $scope.data.decisionData.header, form: $scope.decisionForm});
        for (var i = 0; i < $scope.data.supplierAndCommunicationData.supplierCascade.length; i++) {
            $scope.supplierIndex[i] = i + 1;
        }
        ctrl.collectSmartFormErrors();
        ToolbarService.setScrollMenu($scope.scrollList);
        defineButtons();
        updateAvailableSft();
        ctrl.collectSupplierErrors();
        if ($scope.data.headerData.lotRelation) {
            $scope.$watch(function () {
                return $scope.data.headerData.lotRelation.relation.assigned.length;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue === 0) {
                        $scope.data.supplierAndCommunicationData.supplierCascade.length = 0;
                    }
                    else {
                        dataGen.getData({}, {lotId: $scope.data.headerData.lotRelation.relation.assigned[0].id}, "/rfx/cascade").then(function (data) {
                            $scope.data.supplierAndCommunicationData.supplierCascade = data.data.cascade;
                        });
                    }
                    ctrl.collectSupplierErrors();
                }
            });
        }
    });

    ctrl.save = function () {
        return dataGen.postAsForm($scope, {rfqc: $scope.data}, "/rfx/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if ($routeParams.copy) {
                $redirect.redirectTo(null, "/rfqclist");
            }
            else {
                BackService.back();
            }
        });
    };

    ctrl.saveAndActivate = function () {
        return dataGen.postAsForm($scope, {rfqc: $scope.data}, "/rfx/saveandactivate").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if ($routeParams.copy) {
                $redirect.redirectTo(null, "/rfqclist");
            }
            else {
                BackService.back();
            }
        });
    };

    ctrl.saveAndDeactivate = function () {
        return dataGen.postAsForm($scope, {rfqc: $scope.data}, "/rfx/saveanddeactivate").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if ($routeParams.copy) {
                $redirect.redirectTo(null, "/rfqclist");
            }
            else {
                BackService.back();
            }
        });
    };

    ctrl.confirmDelete = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.delete = function () {
        return dataGen.postAsForm($scope, {rfqcId: $routeParams.id}, "/rfx/delete").then(function () {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            BackService.back();
        });
    };

    ctrl.redirectToCopy = function () {
        $redirect.redirectTo(null, "/rfqcedit/" + $routeParams.id + "/true");
    };

    ctrl.saveAndRedirectCopy = function () {
        return dataGen.postAsForm($scope, {rfqc: $scope.data}, "/rfx/save").then(function () {
            ctrl.redirectToCopy();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.copy = function (event) {
        if ($scope.data.readOnly || $scope.dialogData.$pristine) {
            ctrl.redirectToCopy();
        }
        else {
            RedirectAndSaveService.showRedirectAndSaveDialog(ctrl.saveAndRedirectCopy, ctrl.redirectToCopy, event,
                $scope.trns.saveMessageRedirect, $scope.trns.save, $scope.trns.abort, $scope.trns.noSave,
                false);
        }
    };

    $scope.tinymceOptions = $config.tinymceOptions;

    ctrl.collectErrors = function () {
        $scope.errorListForSave.length = 0;
        $scope.errorListForSave = $scope.errorListForSave.concat($scope.attachmentErrorList);
        $scope.errorListForSave = $scope.errorListForSave.concat($scope.supplierErrorList);

        $scope.errorList.length = 0;
        $scope.errorList = $scope.errorList.concat($scope.attachmentErrorList);
        $scope.errorList = $scope.errorList.concat($scope.supplierErrorList);
        $scope.errorList = $scope.errorList.concat($scope.headerErrorList);
        $scope.errorList = $scope.errorList.concat($scope.smartFormErrorList);
    };

    ctrl.collectSupplierErrors = function () {
        $scope.supplierErrorList.length = 0;
        if ($scope.data.supplierAndCommunicationData && $scope.data.supplierAndCommunicationData.supplierSetConfig.selected.id === 2) {
            $scope.data.supplierAndCommunicationData.askOutlets.value = false;
            $scope.data.supplierAndCommunicationData.allowTextCustomisation.value = false;

            var foundRanks = [];
            for (var i = 0; i < $scope.data.supplierAndCommunicationData.supplierCascade.length; i++) {
                if ($scope.data.supplierAndCommunicationData.supplierCascade[i].rank.value === 0 ||
                    foundRanks.includes($scope.data.supplierAndCommunicationData.supplierCascade[i].rank.value)) {
                    $scope.supplierErrorList.push($scope.trns.errorUniqueRanks);
                }
                foundRanks.push($scope.data.supplierAndCommunicationData.supplierCascade[i].rank.value)
            }

            if ($scope.data.headerData.lotRelation && $scope.data.headerData.lotRelation.relation.assigned.length > 1) {
                $scope.supplierErrorList.push($scope.trns.errorMaxNumberLots);
            }
        }
        ctrl.collectErrors();
    };

    ctrl.collectSmartFormErrors = function () {
        $scope.smartFormErrorList.length = 0;
        var posAndSFData = $scope.data.positionAndSmartFormData;
        if (posAndSFData.allowAddSmartformBuyer.value || posAndSFData.allowAddSmartformSupplier.value) {
            var foundOneSmartFormPosition = false;

            for (var i = 0; i < posAndSFData.assignedSmartForms.length; i++) {
                if (!posAndSFData.allowAddQuestionBuyer.value || !posAndSFData.assignedSmartForms[i].isInformation) {
                    foundOneSmartFormPosition = true;
                    break;
                }
            }
            if (!foundOneSmartFormPosition) {
                $scope.smartFormErrorList.push($scope.trns.noSmartFormError);
                $scope.noSmartForm = true;
            }
            else {
                $scope.noSmartForm = false
            }
        }
        ctrl.collectErrors();
    };

    $scope.$watch(function () {
        return $scope.attachmentErrorList.length;
    }, function (newValue, oldValue) {
        if (newValue != oldValue) {
            ctrl.collectErrors();
        }
    });

    this.collectHeaderErrors = function (newContact) {
        $scope.headerErrorList.length = 0;

        if (!newContact && !$scope.headerForm.contactUser.$error.selectedItem) {
            $scope.headerErrorList.push($scope.trns.noContactError);
        }
        ctrl.collectErrors();
    };

    $scope.$watch(function () {
        if ($scope.data && $scope.data.supplierAndCommunicationData && $scope.data.supplierAndCommunicationData.supplierSetConfig) {
            return $scope.data.supplierAndCommunicationData.supplierSetConfig.selected;
        }
        else {
            return false;
        }
    }, function (newValue, oldValue) {
        if (newValue != oldValue && newValue.id != oldValue.id) {
            ctrl.collectSupplierErrors();
        }
    });

    ctrl.addSupplier = function () {
        var indexToSet = 1;
        for (var i = $scope.data.supplierAndCommunicationData.supplierCascade.length - 1; i >= 0; i--) {
            if ($scope.data.supplierAndCommunicationData.supplierCascade[i] == null ||
                !$scope.data.supplierAndCommunicationData.supplierCascade[i].removed) {
                indexToSet = $scope.supplierIndex[i] + 1;
                break;
            }
        }
        $scope.data.supplierAndCommunicationData.supplierCascade.push(null);
        $scope.supplierIndex[$scope.supplierIndex.length] = indexToSet;
        ctrl.collectSupplierErrors();
    };

    ctrl.removeSupplier = function (index) {
        if ($scope.data.supplierAndCommunicationData.supplierCascade[index] == null) {
            $scope.data.supplierAndCommunicationData.supplierCascade[index] = {removed: true};
        }
        else {
            $scope.data.supplierAndCommunicationData.supplierCascade[index].removed = true;
        }
        for (var i = index + 1; i < $scope.supplierIndex.length; i++) {
            $scope.supplierIndex[i]--;
        }
        ctrl.collectSupplierErrors();
    };

    this.showNumSupplierTextDialog = function (event) {
        $mdDialog.show({
            controller: "NumSupplierTextDialogCtrl",
            controllerAs: "numSupplierTextDialogCtrl",
            templateUrl: "modules/rfx/templates/numsuppliertext.dialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                label: $scope.data.supplierAndCommunicationData.numSupplierText.label
            }
        })
            .then(function (answer) {
                $scope.data.supplierAndCommunicationData.numSupplierText.value = answer.text;
            }, function () {
            });
    };

    ctrl.addBuyerSmartForm = function () {
        $scope.data.positionAndSmartFormData.assignedSmartForms.push(
            {
                sftName: $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected.value,
                sftId: $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected.id,
                minNumber: 0,
                maxNumber: 0,
                isBuyer: $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected.isBuyer,
                isSupplier: $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected.isSupplier
            });
        ctrl.markAvailableSmartForm($scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected.id, true);
        if(impactX.isDefined($scope.data, 'positionAndSmartFormData.availableSupplierSmartForms.selected.id') === $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected.id) {
            $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected = null;
        }
        $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected = null;
        ctrl.collectSmartFormErrors();
    };

    ctrl.addSupplierSmartForm = function () {
        $scope.data.positionAndSmartFormData.assignedSmartForms.push(
            {
                sftName: $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected.value,
                sftId: $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected.id,
                minNumber: 0,
                maxNumber: 0,
                isBuyer: $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected.isBuyer,
                isSupplier: $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected.isSupplier
            });
        ctrl.markAvailableSmartForm($scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected.id, true);
        if(impactX.isDefined($scope.data, 'positionAndSmartFormData.availableBuyerSmartForms.selected.id') === $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected.id) {
            $scope.data.positionAndSmartFormData.availableBuyerSmartForms.selected = null;
        }
        $scope.data.positionAndSmartFormData.availableSupplierSmartForms.selected = null;
        ctrl.collectSmartFormErrors();
    };

    ctrl.removeSmartForm = function (toRemove) {
        var index = $scope.data.positionAndSmartFormData.assignedSmartForms.indexOf(toRemove);
        if (index >= 0) {
            ctrl.markAvailableSmartForm(toRemove.sftId, false);
            $scope.data.positionAndSmartFormData.assignedSmartForms.splice(index, 1);
            ctrl.collectSmartFormErrors();
        }
    };

    ctrl.markAvailableSmartForm = function (sftId, assigned) {
        for (var i = 0; i < $scope.data.positionAndSmartFormData.availableBuyerSmartForms.entries.length; i++) {
            if ($scope.data.positionAndSmartFormData.availableBuyerSmartForms.entries[i].id === sftId) {
                $scope.data.positionAndSmartFormData.availableBuyerSmartForms.entries[i].assigned = assigned;
            }
        }
        for (var j = 0; j < $scope.data.positionAndSmartFormData.availableSupplierSmartForms.entries.length; j++) {
            if ($scope.data.positionAndSmartFormData.availableSupplierSmartForms.entries[j].id === sftId) {
                $scope.data.positionAndSmartFormData.availableSupplierSmartForms.entries[j].assigned = assigned;
            }
        }
        updateAvailableSft();
    };

    ctrl.checkSupplierSetConfig = function (event) {
        if ($scope.data.supplierAndCommunicationData.supplierSetConfig.selected && $scope.data.supplierAndCommunicationData.supplierSetConfig.selected.id === 2) {
            if (($scope.data.headerData.tenderRelation && $scope.data.headerData.tenderRelation.relation.assigned.length > 0)
             || ($scope.data.headerData.contractRelation.relation.assigned && $scope.data.headerData.contractRelation.relation.assigned.length > 0)) {
                WarningService.showWarningDialogNoCallback(event, $scope.trns.warning, TranslationService.get("confirm"),
                    null, [$scope.trns.warningTenderContractRemoval]);
                $scope.data.deadlinesData.answerVisibility.selected = $scope.data.deadlinesData.answerVisibility.entries[0];
                $scope.data.headerData.useEncryptedOffers.value = false;
            }
        }
    }

    ctrl.useModuleCommunicationChanged = function ()
    {
        if (!$scope.data.supplierAndCommunicationData.useModuleCommunication.value) {
            $scope.data.supplierAndCommunicationData.onlyPublicConversation.value = false;
        }
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.saveAndActivate,
                action: ctrl.saveAndActivate,
                type: 'validation',
                condition: isNotActivated,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.saveAndDeactivate,
                action: ctrl.saveAndDeactivate,
                type: 'validation',
                condition: canDeactivate,
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.copyConfiguration,
                action: ctrl.copy,
                type: 'validation',
                condition: canCopy,
                process: 'RFQCEdit',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.confirmDelete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && $scope.data.id > 0 && !$routeParams.copy;
    }

    function canCopy() {
        return $scope.data.id > 0 && !$routeParams.copy;
    }

    function isNotActivated() {
        return isEditable() && $scope.data.headerData && !$scope.data.headerData.isActivated;
    }

    function canDeactivate() {
        return isEditable() && $scope.data.headerData && $scope.data.headerData.canBeDeactivated;
    }

    function hasErrors() {
        return $scope.errorList.length;
    }

    function getErrors() {
        return $scope.errorList;
    }

    function updateAvailableSft() {
        $scope.availableBuyerSft = $scope.data.positionAndSmartFormData.availableBuyerSmartForms.entries.filter((e) => !e.assigned);
        $scope.availableSupplierSft = $scope.data.positionAndSmartFormData.availableSupplierSmartForms.entries.filter((e) => !e.assigned);
    }
}